<template>
  <modal
    :show="isVisible"
    :title="t('Adicionar créditos')"
    elem-id="modal_staff_credits_topup"
    size="compactDesktop"
    :close-label="t('Cancelar')"
    :save-label="t('Adicionar')"
    :save-fn="handleSave"
    @close="handleClose"
    @dismiss="handleClose"
  >
    <template v-if="isVisible">
      <staff-credits-topup-form
        ref="formRef"
        :franquia-id="preselectedFranquiaId"
        @submit-success="handleSubmitSuccess"
      />
    </template>
  </modal>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { eventBus } from '../../../eventBus';
import { log } from '../../../utils/DebugLogger';
import StaffCreditsTopupForm from './StaffCreditsTopupForm.vue';

interface ModalOpenPayload {
  franquia_id?: number | string;
  franquiaId?: number | string;
}

const { t } = useI18n();

const isVisible = ref(false);
const preselectedFranquiaId = ref<number | string | null>(null);
const formRef = ref<InstanceType<typeof StaffCreditsTopupForm> | null>(null);

function handleOpen(payload?: ModalOpenPayload): void {
  log('StaffCreditsTopupModal', 'handleOpen', 'Opening topup modal', payload);
  preselectedFranquiaId.value = payload?.franquia_id ?? payload?.franquiaId ?? null;
  isVisible.value = true;
}

function handleClose(): void {
  log('StaffCreditsTopupModal', 'handleClose', 'Closing topup modal');
  isVisible.value = false;
  preselectedFranquiaId.value = null;
}


async function handleSave(): Promise<void> {
  log('StaffCreditsTopupModal', 'handleSave', 'Triggering form submit');
  await formRef.value?.handleSubmit();
}

function handleSubmitSuccess(): void {
  log('StaffCreditsTopupModal', 'handleSubmitSuccess', 'Topup saved, closing modal');
  eventBus.emit('staffCreditsTopup.saved');
  eventBus.emit('staff-credits.refresh');
  eventBus.emit('globalMessage.success', t('Créditos adicionados com sucesso'));
  handleClose();
}

onMounted(() => {
  log('StaffCreditsTopupModal', 'mounted', 'Registering modal listener');
  eventBus.on('modal.staff-credits-topup.open', handleOpen);
});

onBeforeUnmount(() => {
  log('StaffCreditsTopupModal', 'beforeUnmount', 'Removing modal listener');
  eventBus.off('modal.staff-credits-topup.open', handleOpen);
});
</script>
